export const inputConstants = {
    ADD: 'INPUT_ADD',
    REMOVE: 'INPUT_REMOVE',
    UPDATE: 'INPUT_UPDATE'
}
